var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRegistration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9091 1.36364H9.05909C8.77273 0.572727 8.02273 0 7.13636 0C6.25 0 5.5 0.572727 5.21364 1.36364H2.36364C1.61364 1.36364 1 1.97727 1 2.72727V13.6364C1 14.3864 1.61364 15 2.36364 15H11.9091C12.6591 15 13.2727 14.3864 13.2727 13.6364V2.72727C13.2727 1.97727 12.6591 1.36364 11.9091 1.36364ZM7.13636 1.36364C7.51136 1.36364 7.81818 1.67045 7.81818 2.04545C7.81818 2.42045 7.51136 2.72727 7.13636 2.72727C6.76136 2.72727 6.45455 2.42045 6.45455 2.04545C6.45455 1.67045 6.76136 1.36364 7.13636 1.36364ZM11.9091 13.6364H2.36364V2.72727H3.72727V4.77273H10.5455V2.72727H11.9091V13.6364Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRegistration);
export default __webpack_public_path__ + "static/media/ic-registration.db7542692426a848f032b411b4a2282e.svg";
export { ForwardRef as ReactComponent };